<template>
  <div class="main-wrapper">
    <sidebar-menu
      width="300px"
      widthCollapsed="50px"
      :menu="menu"
      :relative="true"
      :collapsed="collapsed"
      @update:collapsed="updateCollapsed($event)"
      class="side-menu"
    >
      <template #toggle-icon>
        <v-tooltip location="end" text="開く / 閉じる">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              icon="$mdiFormatAlignJustify"
              size="x-small"
            ></v-icon>
          </template>
        </v-tooltip>
      </template>
    </sidebar-menu>
    <div class="main-container">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type {
  SidebarComponentItem,
  SidebarHeaderItem,
  SidebarItem,
} from "vue-sidebar-menu";
import type { ContractInfo, ContractSummary } from "@/apis/ContractApi";
import { mapState } from "vuex";
import PermissionService from "@/services/PermissionService";
import { useSideMenu } from "@/composable/side-menu";

export function getTrafficLogMenus(
  summary: ContractSummary,
  permission: PermissionService,
  contractList: ContractInfo["contractList"]
): Array<SidebarItem> {
  const isViewDelegate = permission.isViewDelegate();
  const hasCpa5Gsa = contractList.some((e) => e.accessType === "CPA_5GSA");
  return [
    {
      href: "/report",
      title: "トラフィック/セッション/統計情報",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiChartLine" },
      },
      hidden:
        !summary.isTrafficInfo &&
        !summary.isSessionInfo &&
        !summary.isStatisticsInfo,
    },
    {
      href: "/report/appliance-log",
      title: "アプライアンスログ",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiFileDocumentOutline" },
      },
      hidden: isViewDelegate,
    },
    {
      href: "/report/remote/access/account",
      title: "CPA認証ID",
      icon: {
        element: "v-icon",
        attributes: { icon: "$mdiFileDocument" },
      },
      hidden: !hasCpa5Gsa,
    },
  ] as Array<SidebarItem>;
}

export default defineComponent({
  name: "TrafficLogMain",
  setup() {
    const { collapsed, updateCollapsed } = useSideMenu();
    return { collapsed, updateCollapsed };
  },
  computed: {
    ...mapState("user", {
      contractInfo: "contractInfo",
      contractSummary: "contractSummary",
    }),
    menu(): Array<SidebarItem | SidebarComponentItem | SidebarHeaderItem> {
      return getTrafficLogMenus(
        this.contractSummary,
        this.$service.permission,
        this.contractInfo.contractList
      );
    },
  },
});
</script>
